import styled from 'styled-components';
import {typographyStyle} from '@/components/Typography';
import {palette} from '@/styles';

export const GhostTable = styled.table`
  width: 100%;
  border-spacing: 0;
  tr,
  td {
    border: 0;
    padding: 0;
  }
  tr:not(:last-of-type) {
    td {
      padding-bottom: 12px;
    }
  }
  tr.indent {
    td:first-of-type {
      padding-left: 8px;
      border-left: solid 2px #d9d9d9;
    }
    & + tr.next-indent-row {
      td {
        padding-top: 12px;
      }
    }
  }
  td {
    color: ${palette.textPrimary};
    vertical-align: baseline;
    word-break: break-all;
  }
  td:first-of-type {
    box-sizing: content-box;
    width: 98px;
    font-weight: 700;
    color: ${palette.textSecondary};
    padding-right: 16px;
    white-space: nowrap;
  }
  ${{...typographyStyle.medium14}}
`;

export * from './AddressRow';
